import { render } from "./OverviewDetails.vue?vue&type=template&id=50b8de39&scoped=true"
import script from "./OverviewDetails.vue?vue&type=script&lang=js"
export * from "./OverviewDetails.vue?vue&type=script&lang=js"

import "./OverviewDetails.vue?vue&type=style&index=0&id=50b8de39&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b8de39"]])

export default __exports__